import React, { useState } from 'react';

// material
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

// router
import { Link, useHistory } from 'react-router-dom'

// redux
import { useAppSelector, useAppDispatch } from '../../hooks'
import { setSelectedStaffProfile } from '../../managers/redux/slices/authAccount'

import { StaffProfile } from '../../API';
import Subscription from './Subscription';

export default function SelectStaffProfile() {

    const history = useHistory()

    // redux state
    const dispatch = useAppDispatch()
    const authAccount = useAppSelector(state => state.authAccount)

    async function _handleStaffProfileSelection(staffProfile: StaffProfile) {
        await dispatch(setSelectedStaffProfile(staffProfile))
    }

    if (authAccount.staffProfiles && authAccount.staffProfiles.length > 0) {
        return (
            <Container component="main" maxWidth="lg" className="mt-5">
                <CssBaseline />
                <Grid
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{ marginTop: '100px' }}
                >
                    <Typography variant="h2" sx={{ color: 'black' }}>
                        Select Organization
                    </Typography>
                    {
                        authAccount.staffProfiles.map((staffProfile: StaffProfile) => {
                            return (
                                <Button fullWidth variant="contained" className="my-2" onClick={() => { _handleStaffProfileSelection(staffProfile) }}>
                                    <Typography variant="body1">{staffProfile.organization && staffProfile.organization.name ? staffProfile.organization.name : ''}</Typography>
                                </Button>
                            )
                        })
                    }
                </Grid>
            </Container>
        );
    } else {
        return (
            <Container component="main" className="mt-5">
                <CssBaseline />
                <Grid
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                >
                    <div className="row">
                        <div className="col-12">
                            <Typography variant="h3">No Organization Found</Typography>
                            <Typography>You currently don't have any Organizations attached to the staff side of your account. If you're on staff with an Organization that uses Latent, have them invite you to their organization on Latent, or use the button below to register your organization with Latent if your organization isn't already on Latent.</Typography>
                            <Button variant="contained" className="mt-5" onClick={() => history.push('/admin/organization-registration')}>Add your Organization</Button>
                        </div>
                    </div>
                </Grid>
            </Container>
        );
    }
}